/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestUpdateNoticeRequest
 */
export interface RequestUpdateNoticeRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateNoticeRequest
     */
    baseId: number;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdateNoticeRequest
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdateNoticeRequest
     */
    displayAt: string;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateNoticeRequest
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateNoticeRequest
     */
    tenantId: number;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdateNoticeRequest
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateNoticeRequest
     */
    userId: number;
    /**
     * nilのときは変更しない
     * @type {boolean}
     * @memberof RequestUpdateNoticeRequest
     */
    visible?: boolean;
}

/**
 * Check if a given object implements the RequestUpdateNoticeRequest interface.
 */
export function instanceOfRequestUpdateNoticeRequest(value: object): value is RequestUpdateNoticeRequest {
    if (!('baseId' in value) || value['baseId'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('displayAt' in value) || value['displayAt'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function RequestUpdateNoticeRequestFromJSON(json: any): RequestUpdateNoticeRequest {
    return RequestUpdateNoticeRequestFromJSONTyped(json, false);
}

export function RequestUpdateNoticeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestUpdateNoticeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'baseId': json['base_id'],
        'content': json['content'],
        'displayAt': json['display_at'],
        'id': json['id'],
        'tenantId': json['tenant_id'],
        'title': json['title'],
        'userId': json['user_id'],
        'visible': json['visible'] == null ? undefined : json['visible'],
    };
}

export function RequestUpdateNoticeRequestToJSON(json: any): RequestUpdateNoticeRequest {
    return RequestUpdateNoticeRequestToJSONTyped(json, false);
}

export function RequestUpdateNoticeRequestToJSONTyped(value?: RequestUpdateNoticeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base_id': value['baseId'],
        'content': value['content'],
        'display_at': value['displayAt'],
        'id': value['id'],
        'tenant_id': value['tenantId'],
        'title': value['title'],
        'user_id': value['userId'],
        'visible': value['visible'],
    };
}

